import React from "react";
import * as S from "./orderStatusIndicator.style";

interface OrderStatusIndicatorProps {
  orderState: string;
  강조?: boolean;
}

const OrderStatusIndicator = ({
  orderState,
  강조 = false,
}: OrderStatusIndicatorProps) => {
  const renderStatusText = () => {
    switch (orderState) {
      case "COMPLETED":
        return (
          <S.StatusTextContainer>
            <S.StatusText color="default">세금계산서 요청완료</S.StatusText>
            <span> &gt; </span>
            <S.StatusText color="default">세금계산서 발행완료</S.StatusText>
            <span> &gt; </span>
            <S.StatusText color="COMPLETED" accent={true}>
              완료
            </S.StatusText>
          </S.StatusTextContainer>
        );
      case "COMPLETED_REVIEW":
        return (
          <S.StatusTextContainer>
            <S.StatusText color="COMPLETED_REVIEW" accent={true}>
              운송완료검토중
            </S.StatusText>
            <span> &gt; </span>
          </S.StatusTextContainer>
        );
      case "TAX_INVOICE_REQUEST_COMPLETED":
        return (
          <S.StatusTextContainer>
            <S.StatusText color="default">운송완료검토중</S.StatusText>
            <span> &gt; </span>
            <S.StatusText color="TAX_INVOICE_REQUEST_COMPLETED" accent={true}>
              세금계산서 요청완료
            </S.StatusText>
          </S.StatusTextContainer>
        );
      case "TAX_INVOICE_ERROR":
        return (
          <S.StatusTextContainer>
            <S.StatusText color="default">운송완료검토중</S.StatusText>
            <span> &gt; </span>
            <S.StatusText color="TAX_INVOICE_ERROR" accent={true}>
              세금계산서 오류
            </S.StatusText>
          </S.StatusTextContainer>
        );
      case "TAX_INVOICE_PUBLISHED_COMPLETED":
        return (
          <S.StatusTextContainer>
            <S.StatusText color="default">운송완료검토중</S.StatusText>
            <span> &gt; </span>
            <S.StatusText color="default">세금계산서 요청완료</S.StatusText>
            <span> &gt; </span>
            <S.StatusText color="TAX_INVOICE_PUBLISHED_COMPLETED" accent={true}>
              세금계산서 발행완료
            </S.StatusText>
          </S.StatusTextContainer>
        );
      default:
        return (
          <S.StatusTextContainer>
            <S.StatusText color="default">운송완료검토중</S.StatusText>
            <span> &gt; </span>
            <S.StatusText color="default">세금계산서 요청완료</S.StatusText>
            <span> &gt; </span>
            <S.StatusText color="default">세금계산서발행완료</S.StatusText>
          </S.StatusTextContainer>
        );
    }
  };

  return (
    <S.OrderStatusIndicatorContainer>
      {renderStatusText()}
    </S.OrderStatusIndicatorContainer>
  );
};

export default OrderStatusIndicator;
